window.lang2 =
{
  "general": {
    "meta": {
      "tags": "Atzīmēts ar \"{{ tags }}\"",
      "page": "Lapa {{ page }}"
    },
    "404": {
      "title": "404 Lapa nav atrasta",
      "subtext_html": "Jūsu pieprasītā lapa nepastāv.",
      "click_here": "Noklikšķiniet šeit",
      "continue_shopping": " lai turpinātu iepirkties."
    },
    "breadcrumbs": {
      "home": "Sākums",
      "cart": "Grozs",
      "home_link_title": "Atpakaļ uz sākumlapu"
    },
    "newsletter_form": {
      "newsletter_email": "jusu-epasts@piemers.com",
      "submit": "Abonēt",
      "newsletter_text": "ievadiet savu e-pasta adresi"
    },
    "search": {
      "title": "Meklējiet produktus mūsu vietnē",
      "placeholder": "Meklēt",
      "submit": "Meklēt",
      "no_results": "Nav rezultātu",
      "view_results": "Skatīt visus rezultātus"
    },
    "currency": {
      "change_text": "Veikala valūta ir mainīta",
      "currency": "Valūta"
    },
     "language": {
      "language": "Valoda"
    },
    "sidebar": {
      "sidebar_more": "Sānjosla"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Publicēts {{ date }}, autors: {{ author }}",
      "older_post": "Vecāks ieraksts",
      "newer_post": "Jaunāks ieraksts",
      "tags": "Birkas",
      "comment_meta_html": "{{ author }} {{ date }}",
      "read_more": "Lasīt vairāk"
    },
    "comments": {
      "title": "Atstājiet komentāru",
      "name": "Vārds",
      "email": "E-pasts",
      "message": "Komentārs",
      "post": "Publicēt komentāru",
      "moderated": "Lūdzu, ņemiet vērā, ka komentāri pirms publicēšanas ir jāapstiprina",
      "success_moderated": "Jūsu komentārs ir veiksmīgi publicēts. Tā kā mūsu blogs tiek moderēts, mēs to publicēsim pēc neilga laika.",
      "success": "Jūsu komentārs ir veiksmīgi publicēts. Paldies!",
      "comments_with_count": {
        "one": "{{ count }} komentārs",
        "other": "{{ count }} komentāri"
      },
      "note": "Visi bloga komentāri pirms publicēšanas tiek pārskatīti"
    },
    "sidebar": {
      "recent_articles": "Jaunākie raksti",
      "categories": "Kategorijas",
      "tag_cloud": "Birku mākonis"
    }
  },
  "cart": {
    "general": {
      "title": "Iepirkumu grozs",
      "remove": "Noņemt",
      "note": "Īpašas piezīmes pārdevējam",
      "subtotal": "Starpsumma:",
      "shipping_at_checkout": "Piegāde un atlaides tiek aprēķinātas norēķinoties",
      "update": "Atjaunināt grozu",
      "checkout": "Norēķināties",
      "empty": "Jūsu iepirkumu grozs pašlaik ir tukšs.",
      "continue_browsing_html": "Turpiniet pārlūkošanu <a href=\"\/collections\/all\">šeit<\/a>.",
      "view_cart": "Skatīt grozu",
      "close_cart": "Aizvērt grozu",
      "shopping_cart": "Iepirkumu grozs",
      "cart_supermarket": "Iepirkumu grozs",
      "button_checkout": "Doties uz norēķiniem",
      "continue_shopping": "Turpināt iepirkties",
      "go_to_cart": "Doties uz grozu",
      "label": "piezīme",
      "label_text": "Papildu piezīmes",
      "shipping_calculator_button": "Aprēķināt piegādes izmaksas",
      "shipping_calculator_calculating": "Aprēķina...",
      "shipping_calculator_error_message": "Kļūda: lūdzu, ievadiet piegādes informāciju pa labi",
      "shipping_calculator_success_many_rates": {
        "there_are": "Ir pieejamas",
        "shipping_rates_available_for": "piegādes likmes uz ",
        "starting_at": ", sākot no "
      },
      "shipping_calculator_success_one_rate": "Šim galamērķim ir pieejama viena piegādes likme",
      "shipping_calculator_success_no_rate": "Šim pasūtījumam un galamērķim nav pieejama neviena piegādes likme.",
      "shipping_calculator_success_at": "par"
    },
    "label": {
      "product": "Prece",
      "price": "Cena",
      "quantity": "Daudzums",
      "total": "Kopā",
      "or": "vai",
      "quick_cart": "Ātrais grozs",
      "your_order": "Jūsu pasūtījums",
      "order_summary": "Pasūtījuma kopsavilkums"
    },
    "ajax_cart": {
      "continue_shopping": "Turpināt iepirkties",
      "go_to_cart": "Doties uz grozu",
      "success_text": "Pievienots grozam.",
      "error": "Kļūda",
      "loading": "Notiek ielāde",
      "close": "Aizvērt",
      "popup_cart_des": "Šīs preces ir pievienotas jūsu grozam:",
      "items_in_your_cart": "preces jūsu iepirkumu grozā "
    }
  },
  "collections": {
    "general": {
      "no_matches": "Atvainojiet, jūsu produktu meklēšana nedeva rezultātus.",
      "link_title": "Pārlūkojiet mūsu {{ title }} kolekciju",
      "grid_view": "Režģa skats",
      "list_view": "Saraksta skats",
      "show_more": "Rādīt vairāk",
      "no_more_product": "Nav vairāk produktu",
      "items_count": {
        "one": "Produkts",
        "other": "Produkti"
      },
      "items_with_count": {
        "one": "{{ count }} produkts",
        "other": "{{ count }} produkti"
      },
      "title": "Kolekcijas",
      "shop_now": "Iepirkties tagad",
      "shop_the_collection": "Iepirkties kolekcijā"
    },
    "sidebar": {
      "types": "Produkta veids",
      "vendors": "Pārdevēji",
      "tags": "Birkas",
      "clear": "Notīrīt",
      "clear_all": "Notīrīt visu",
      "refined_by": "Filtrēts pēc",
      "sidebar_more":"Filtrēt pēc"
    },
    "sorting": {
      "title": "Kārtot pēc",
      "featured": "Izcelts",
      "best_selling": "Vislabāk pārdotie",
      "az": "Alfabētiski, A-Z",
      "za": "Alfabētiski, Z-A",
      "price_ascending": "Cena, no zemākās uz augstāko",
      "price_descending": "Cena, no augstākās uz zemāko",
      "date_descending": "Datums, no jaunākā uz vecāko",
      "date_ascending": "Datums, no vecākā uz jaunāko"
    },
    "toolbar": {
      "view_as": "Skatīt kā",
      "item_per_page": "Rindas lapā",
      "previous": "Iepriekšējais",
      "next": "Nākamais",
      "show": "Rādīt",
      "all": "Visi",
      "showing": "Rāda",
      "of": "no"
    }
  },
  "contact": {
    "form": {
      "name": "Vārds",
      "email": "E-pasts",
      "address": "Jūsu adrese",
      "phone": "Tālruņa numurs",
      "message": "Ziņojums",
      "placeholder_message": "Lūdzu, atstājiet savu komentāru šeit",
      "send": "Nosūtīt",
      "send_question": "Nosūtīt jautājumu",
      "post_success": "Paldies, ka sazinājāties ar mums. Mēs ar jums sazināsimies pēc iespējas ātrāk.",
      "submit_contact": "Nosūtīt kontaktformu"
    }
  },
  "customer": {
    "account": {
      "title": "Mans konts",
      "details": "Konta informācija",
      "view_addresses": "Skatīt adreses",
      "return": "Atpakaļ uz konta informāciju"
    },
    "activate_account": {
      "title": "Aktivizēt kontu",
      "subtext": "Izveidojiet paroli, lai aktivizētu savu kontu.",
      "password": "Parole",
      "password_confirm": "Apstiprināt paroli",
      "submit": "Aktivizēt kontu",
      "cancel": "Noraidīt uzaicinājumu"
    },
    "addresses": {
      "title": "Jūsu adreses",
      "default": "Noklusējuma",
      "add_new": "Pievienot jaunu adresi",
      "edit_address": "Rediģēt adresi",
      "first_name": "Vārds",
      "last_name": "Uzvārds",
      "company": "Uzņēmums",
      "address1": "Adrese1",
      "address2": "Adrese2",
      "city": "Pilsēta",
      "country": "Valsts",
      "province": "Novads",
      "zip": "Pasta indekss",
      "phone": "Tālrunis",
      "set_default": "Iestatīt kā noklusējuma adresi",
      "add": "Pievienot adresi",
      "update": "Atjaunināt adresi",
      "cancel": "Atcelt",
      "edit": "Rediģēt",
      "delete": "Dzēst",
      "delete_message": "Vai tiešām vēlaties dzēst šo adresi?"
    },
    "logout": {
      "title": "Klients"
    },
    "login": {
      "title": "Klienta pieteikšanās",
      "account": "Konts",
      "returning_customer": "Esošais klients",
      "new_customer": "Jauns klients",
      "email": "E-pasts",
      "password": "Parole",
      "forgot_password": "Vai aizmirsāt paroli?",
      "sign_in": "Pieteikties",
      "cancel": "Atpakaļ uz veikalu",
      "guest_title": "Turpināt kā viesim",
      "guest_continue": "Turpināt",
      "login": "Pieteikties"
    },
    "orders": {
      "title": "Pasūtījumi",
      "order_number": "Pasūtījums",
      "date": "Datums",
      "payment_status": "Maksājuma statuss",
      "fulfillment_status": "Izpildes statuss",
      "total": "Kopā",
      "none": "Jūs vēl neesat veicis nevienu pasūtījumu."
    },
    "order": {
      "title": "Pasūtījums {{ name }}",
      "date": "Veikts {{ date }}",
      "cancelled": "Pasūtījums atcelts {{ date }}",
      "cancelled_reason": "Iemesls: {{ reason }}",
      "billing_address": "Norēķinu adrese",
      "payment_status": "Maksājuma statuss",
      "shipping_address": "Piegādes adrese",
      "fulfillment_status": "Izpildes statuss",
      "discount": "Atlaide",
      "shipping": "Piegāde",
      "tax": "Nodokļi",
      "product": "Prece",
      "sku": "SKU",
      "price": "Cena",
      "quantity": "Daudzums",
      "total": "Kopā",
      "fulfilled_at": "Izpildīts {{ date }}",
      "subtotal": "Starpsumma"
    },
    "recover_password": {
      "title": "Atiestatīt paroli",
      "email": "E-pasts",
      "submit": "Nosūtīt",
      "cancel": "Atcelt",
      "subtext": "Mēs nosūtīsim jums e-pastu paroles atiestatīšanai.",
      "success": "Mēs nosūtījām jums e-pastu ar saiti paroles atjaunināšanai."
    },
    "reset_password": {
      "title": "Atiestatīt konta paroli",
      "subtext": "Ievadiet jaunu paroli kontam {{ email }}",
      "password": "Parole",
      "password_confirm": "Apstiprināt paroli",
      "submit": "Atiestatīt paroli"
    },
    "register": {
      "title": "Izveidot kontu",
      "register": "Reģistrēties",
      "first_name": "Vārds",
      "last_name": "Uzvārds",
      "email": "E-pasts",
      "password": "Parole",
      "submit": "Izveidot kontu",
      "cancel": "Atpakaļ uz veikalu"
    },
    "form": {
      "error_message": "Atvainojiet, šķiet, ka kaut kas nogāja greizi. Lūdzu, izlabojiet norādīto un iesniedziet vēlreiz:"
    }
  },
  "home_page": {
    "sections": {
      "frontpage_title": "Sākumlapas kolekcija",
      "featured_title": "Izcelta kolekcija",
      "news_title": "Jaunākās ziņas"
    },
    "onboarding": {
      "modal_title": "Gandrīz gatavs...",
      "no_products_html": "Jūsu sākumlapas kolekcijā nav nevienas preces. Šis vietturis pazudīs, kad <a href=\"\/admin\/collections?tutorial=Frontpage\">pievienosiet šai kolekcijai preci<\/a>.",
      "add_product": "Pievienot produktu",
      "product_title": "Produkta nosaukuma piemērs",
      "no_collections_html": "Šeit nav nevienas kolekcijas, ko parādīt. <a href=\"\/admin\/custom_collections\">Pievienojiet dažas kolekcijas<\/a> noklusējuma sākumlapai.",
      "add_collection": "Pievienot kolekciju",
      "collection_title": "Kolekcijas nosaukuma piemērs"
    },
    "show_more": "Rādīt vairāk",
    "no_more_product": "Nav vairāk produktu"
  },
  "layout": {
    "cart": {
      "title": "Iepirkumu grozs",
      "items_count": {
        "one": "Produkts",
        "other": "Produkti"
      }
    },
    "customer": {
      "account": "Konts",
      "logged_in_as_html": "Pieteicies kā {{ first_name }}",
      "log_out": "Izrakstīties",
      "log_in": "Pieteikties",
      "create_account": "Izveidot kontu",
      "register": "Reģistrēties",
      "title": "Mans konts"
    },
    "footer": {
      "linklist_title": "Ātrās saites",
      "social_title": "Sekojiet jaunumiem",
      "newsletter_title": "Jaunumu vēstule",
      "accepted_payments": "Pieņemtie maksājumi"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Iepriekšējā prece",
      "next_product_html": "Nākamā prece &rarr;",
      "from": "No"
    },
    "product": {
      "sold_out": "Izpārdots",
      "custom_label": "Pielāgota etiķete",
      "bundle_label": "Komplekts",
      "new_label": "Jauns",
      "on_sale_from_html": "<strong>Akcijā<\/strong> no {{ price }}",
      "unavailable": "Nav pieejams",
      "compare_at": "Salīdzināmā cena",
      "quantity": "Daudzums",
      "add_to_cart": "Pievienot grozam",
      "add_all_to_cart": "Pievienot visu grozam",
      "buy_now": "Pirkt tagad",
      "add" : "Pievienot",
      "select_options": "Izvēlēties opcijas",
      "quick_view": "Ātrais skats",
      "sale": "Atlaide",
      "in_stock": "noliktavā",
      "details": "Informācija",
      "out_of_stock": "Izpārdots",
      "many_in_stock": "Daudz noliktavā",
      "you_save": "Jūs ietaupāt",
      "from": "no ",
      "hide_options": "Paslēpt variantus",
      "show_options": "Rādīt variantus",
      "adding": "Pievieno",
      "thank_you": "Paldies",
      "add_more": "Pievienot vairāk",
      "cart_feedback": "pievienots",
      "main_product": "Šī prece"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Šeit ir jūsu {{ value }} dāvanu karte veikalam {{ shop }}!",
      "subtext": "Šeit ir jūsu dāvanu karte!",
      "disabled": "Atspējota",
      "expired": "Derīguma termiņš beidzās {{ expiry }}",
      "active": "Derīga līdz {{ expiry }}",
      "redeem": "Izmantojiet šo kodu norēķinu laikā, lai izmantotu dāvanu karti",
      "shop_link": "Sākt iepirkties",
      "print": "Drukāt"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  },
  "wishlist": {
    "general": {
      "my_wishlist": "Mans vēlmju saraksts",
      "wishlist": "Vēlmju saraksts",
      "product_image": "Attēls",
      "product_name": "Produkta nosaukums",
      "unit_price": "Vienības cena",
      "share_wishlist": "Kopīgot vēlmju sarakstu pa e-pastu",
      "no_login": "Lai izveidotu vēlmju sarakstu, jums ir <a href=\"\/account\/login\">jāpiesakās<\/a> vai <a href=\"\/account\/register\">jāizveido konts<\/a>",
      "no_login_html": "Lai izveidotu vēlmju sarakstu, jums ir <a href=\"\/account\/login\">jāpiesakās<\/a> vai <a href=\"\/account\/register\">jāizveido konts<\/a>.",
      "add_to_wishlist": "Pievienot vēlmju sarakstam",
      "remove_wishlist": "Pievienots vēlmju sarakstam",
      "note": "Jau ir jūsu vēlmju sarakstā",
      "subtext": "Lai izveidotu vēlmju sarakstu, jums ir",
      "sign_in": "jāpiesakās",
      "or": "vai",
      "wishlist_empty": "Izskatās, ka vēl neesat izveidojis vēlmju sarakstu...",
      "create_account": "izveidot kontu"
    }
  }
}
